// Components
import getIcon from "utils/getIcon";

// Styles
import styles from "components/molecules/HeaderStatusInfo/headerStatusInfo.module.css";

export type Background = "green" | "yellow" | "red";

export type HeaderStatusInfoProps = {
	message: React.ReactNode;
	background?: Background;
};

const HeaderStatusInfo = ({ message, background }: HeaderStatusInfoProps) => {
	let bgClass = "";
	let messageClass = "";
	const iconColor = background === "yellow" ? "black" : "white";
	const displayIcon = background === "red" ? "errorStatusBar" : "infoIcon";

	if (background) {
		bgClass = styles[`bg_${background}`];
		messageClass = styles[`text_${background}`];
	}

	return (
		<div className={`${styles?.page_indicator} ${bgClass}`}>
			{getIcon({ icon: displayIcon, iconColor })}
			<span className={`${styles?.page_indicator_message} ${messageClass}`}>{message}</span>
		</div>
	);
};

export default HeaderStatusInfo;
